import {Component, inject, Input} from '@angular/core';
import {AppStore} from '../../../../../shared/store/app.store';
import {SettingsService} from '../../../../../shared/services/settings.service';
import {PhoneFormatPipe} from '../../../../../shared/pipes/phone-format';

@Component({
  selector: 'app-compare-print-footer',
  imports: [
    PhoneFormatPipe
  ],
  templateUrl: './compare-print-footer.component.html',
  styleUrl: './compare-print-footer.component.css',
})
export class ComparePrintFooterComponent {
  public appStore = inject(AppStore);
  public settings = inject(SettingsService);
}
